// Interceptors no window.axios (a instancia global que TODO o app usa hoje
// - ver auditoria da Fase 3: existe um axios "@axios" separado em libs/axios.js,
// mas nao e usado em lugar nenhum). Estender o global em vez de criar um
// terceiro cliente evita fragmentar ainda mais e beneficia os CRUDs
// existentes (Dispositivos/Unidades/Grupos) de graca.
import router from '../router'

window.axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.authorization = 'Bearer ' + token
  }
  return config
})

window.axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.clear()
      router.push('/login').catch(() => {})
    }
    return Promise.reject(error)
  }
)
